// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.default-table tbody .q-tr [rowspan][data-v-43ac7546] {\n  vertical-align: top;\n}\n@supports (position: sticky) or (position: -webkit-sticky) {\n.default-table tbody .q-tr [rowspan]:not(.edittd-text):not(.edittd-textarea):not(.edittd-number):not(.edittd-date):not(.edittd-select) > span[data-v-43ac7546]:not(.descript-span) {\n    position: sticky;\n    top: calc(var(--my-var) + 2px);\n}\n}\n", ""]);
// Exports
module.exports = exports;
